import { Field, Section, Toggle } from "./_shared";

const CHANNEL_META = {
    booking: { label: "Booking.com", color: "bg-[#2563EB]" },
    airbnb: { label: "Airbnb", color: "bg-[#DC2626]" },
    expedia: { label: "Expedia", color: "bg-[#F59E0B]" },
    agoda: { label: "Agoda", color: "bg-[#ff7b02]" },
    vrbo: { label: "Vrbo", color: "bg-[#14B8A6]" },
    google_hotels: { label: "Google Hotels", color: "bg-[#94A3B8]" },
    ical: { label: "iCal import/export", color: "bg-[#64748B]" },
};

export default function Step4Channels({ data, update }) {
    const channels = data.channels || [];
    const updateCh = (idx, patch) => {
        const next = channels.map((c, i) => i === idx ? { ...c, ...patch } : c);
        update({ channels: next });
    };

    return (
        <Section title="Channel Manager" description="Zgjidh OTA-t për shpërndarjen e inventarit. Fut credentials për të filluar sinkronizimin.">
            <div className="space-y-3">
                {channels.map((ch, idx) => {
                    const meta = CHANNEL_META[ch.channel] || { label: ch.channel, color: "bg-slate-500" };
                    return (
                        <div key={ch.channel} className={`rounded-md border bg-background p-3 ${ch.enabled ? "border-primary/40" : "border-border"}`} data-testid={`channel-${ch.channel}`}>
                            <div className="flex items-center gap-3">
                                <div className={`flex h-8 w-8 items-center justify-center rounded-md ${meta.color} text-[11px] font-semibold text-white`}>
                                    {meta.label[0]}
                                </div>
                                <div className="min-w-0 flex-1">
                                    <div className="text-[13px] font-medium">{meta.label}</div>
                                    <div className="text-[11px] text-muted-foreground capitalize">{ch.channel.replace("_", " ")}</div>
                                </div>
                                <Toggle label="" checked={ch.enabled} onChange={(v) => updateCh(idx, { enabled: v })} testId={`toggle-${ch.channel}`} />
                            </div>
                            {ch.enabled && (
                                <div className="mt-3 space-y-3 border-t border-border pt-3">
                                    {ch.channel === "ical" ? (
                                        <Field label="URL iCal" hint="Feed publik vetëm për lexim">
                                            <input className="akm-input" value={ch.ical_url || ""} onChange={(e) => updateCh(idx, { ical_url: e.target.value })} placeholder="https://…/kalendari.ics" />
                                        </Field>
                                    ) : (
                                        <Field label="Kredencialet API" hint="Ruhen të enkriptuara — vetëm super_admin i deshifron">
                                            <input className="akm-input font-mono text-[12px]" value={ch.api_key || ""} onChange={(e) => updateCh(idx, { api_key: e.target.value })} placeholder={`${ch.channel.toUpperCase()}_API_KEY`} />
                                        </Field>
                                    )}
                                    <div className="grid grid-cols-1 gap-2 md:grid-cols-3">
                                        <Toggle label="Sinkronizo disponueshmërinë" checked={ch.sync_availability} onChange={(v) => updateCh(idx, { sync_availability: v })} />
                                        <Toggle label="Sinkronizo rezervimet" checked={ch.sync_reservations} onChange={(v) => updateCh(idx, { sync_reservations: v })} />
                                        <Toggle label="Sinkronizo çmimet" checked={ch.sync_pricing} onChange={(v) => updateCh(idx, { sync_pricing: v })} />
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </Section>
    );
}
